import React from 'react';
import { Trophy, Globe2, LineChart, Banknote } from 'lucide-react';
const features = [{
  icon: Trophy,
  title: 'Proven Results',
  description: 'Over 500 successful campaigns delivered for businesses across the UK.'
}, {
  icon: Globe2,
  title: 'UK-Based Experts',
  description: 'Deep understanding of the local UK market and consumer behavior.'
}, {
  icon: LineChart,
  title: 'Transparent Reporting',
  description: 'Live dashboards and monthly calls. No jargon, just clear data.'
}, {
  icon: Banknote,
  title: 'ROI Focused',
  description: 'We treat your budget like our own. Every pound spent must deliver value.'
}];
export function WhyChooseUs() {
  return <section id="why-us" className="py-24 bg-slate-50" data-id="element-192">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-194">
          <div data-id="element-195">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-196">
              Why Leading UK Brands Trust{' '}
              <span className="text-emerald-600" data-id="element-197">SEO PPC Co</span>
            </h2>
            <p className="text-lg text-slate-600 mb-8" data-id="element-198">
              In a crowded digital landscape, you need a partner who cuts
              through the noise. We combine technical expertise with creative
              strategy to deliver measurable growth.
            </p>

            <div className="space-y-8" data-id="element-199">
              {features.map((feature, index) => <div key={index} className="flex gap-4" data-id="element-200">
                  <div className="flex-shrink-0" data-id="element-201">
                    <div className="w-12 h-12 bg-white rounded-lg shadow-sm flex items-center justify-center border border-slate-100" data-id="element-202">
                      <feature.icon className="w-6 h-6 text-emerald-600" data-id="element-203" />
                    </div>
                  </div>
                  <div data-id="element-204">
                    <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-205">
                      {feature.title}
                    </h3>
                    <p className="text-slate-600" data-id="element-206">{feature.description}</p>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-207">
            <div className="absolute inset-0 bg-emerald-500 rounded-3xl transform rotate-3 opacity-10" data-id="element-208"></div>
            <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Team analyzing SEO data" className="relative rounded-3xl shadow-2xl w-full object-cover h-[600px]" data-id="element-209" />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl border border-slate-100 max-w-xs hidden md:block" data-id="element-210">
              <p className="text-sm font-bold text-slate-500 uppercase tracking-wider mb-2" data-id="element-211">
                Client Satisfaction
              </p>
              <div className="flex items-end gap-2" data-id="element-212">
                <span className="text-4xl font-bold text-slate-900" data-id="element-213">98%</span>
                <span className="text-emerald-500 font-medium mb-1" data-id="element-214">★★★★★</span>
              </div>
              <p className="text-xs text-slate-400 mt-2" data-id="element-215">
                Based on 500+ reviews
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}